/**
 * Used only when `pdfjsLib.version` is missing at runtime (should be rare).
 * Keep this equal to the **minimum** version allowed by `package.json`:
 * `dependencies["pdfjs-dist"]` — for `^5.6.205`, use `5.6.205`.
 * When you bump that dependency, update this string so CDN asset URLs and
 * the worker script stay consistent if the runtime version is ever absent.
 */
export const PDFJS_DIST_FALLBACK_VERSION = "5.7.284";
